function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "play_icn");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-73.000000, -70.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "play_icn",
  transform: "translate(74.000000, 71.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,-0.5 C5.09644063,-0.5 -0.5,5.09644063 -0.5,12 C-0.5,18.9035594 5.09644063,24.5 12,24.5 C18.9035594,24.5 24.5,18.9035594 24.5,12 C24.5,5.09644063 18.9035594,-0.5 12,-0.5 Z M12,0.5 C18.3512746,0.5 23.5,5.64872538 23.5,12 C23.5,18.3512746 18.3512746,23.5 12,23.5 C5.64872538,23.5 0.5,18.3512746 0.5,12 C0.5,5.64872538 5.64872538,0.5 12,0.5 Z",
  id: "Oval",
  fill: "#EFEFEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.0798867,16.0384615 L12.7320951,7.18694444 L7.3843035,16.0384615 L18.0798867,16.0384615 Z M12.732,9.12 L16.307,15.038 L9.157,15.038 L12.732,9.12 Z",
  id: "Triangle",
  fill: "#373737",
  transform: "translate(12.732095, 11.612703) rotate(90.000000) translate(-12.732095, -11.612703) "
}))));

var SvgPlayIcn = function SvgPlayIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_icn.1baf7cc0.svg";
export { ForwardRef as ReactComponent };